export default "__VITE_ASSET__DoWULfoN__"